import { createContext, useCallback, useContext, useState } from 'react';

import { IFCWithChildren } from '~/common/interfaces/IFCWithChildren';

interface ISidebarContextData {
  collapsed: boolean;
  collapse: () => void;
  toggleSatoshiAiDrawer: () => void;
}

const SidebarContext = createContext({} as ISidebarContextData);

const SidebarProvider: IFCWithChildren = ({ children }) => {
  const [collapsed, setCollapsed] = useState<boolean>(false);

  const collapse = useCallback(() => {
    setCollapsed((prev) => !prev);
  }, []);

  const toggleSatoshiAiDrawer = useCallback(() => {
    //
  }, []);

  return (
    <SidebarContext.Provider
      value={{
        collapsed,
        collapse,
        toggleSatoshiAiDrawer,
      }}
    >
      {children}
    </SidebarContext.Provider>
  );
};

const useSidebar = (): ISidebarContextData => {
  return useContext(SidebarContext);
};

export { SidebarProvider, useSidebar };
